














































































































































import { Vue, Component } from "vue-property-decorator";
import { Template } from "@/models/template";
import TruncatedText from "../TruncatedText.vue";

@Component({
  components: {
    TruncatedText
  }
})
export default class RequestList extends Vue {
  // Vuex store with lightweight typed wrapper
  readonly store = this.$store.direct;

  get requests() {
    return this.store.state.batch.selected.raw_requests;
  }

  get loading() {
    return !!this.store.state.loading;
  }

  set loading(val: boolean) {
    return;
  }

  get valid() {
    return true;
  }
}
